import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal, RevealGroup, RevealItem } from "@/components/motion/Reveal";
import { TrustBand } from "@/components/TrustBand";
import { SERVICE_PAGES } from "@/data/content";

export default function ServicePage({ slug }) {
  const page = SERVICE_PAGES[slug];
  if (!page) return null;

  return (
    <div className="container-page pb-24 pt-8 sm:pt-10" data-testid="service-page" data-slug={slug}>
      <Breadcrumb>
        <BreadcrumbList className="font-mono text-[10.5px] uppercase tracking-mono text-muted-foreground">
          <BreadcrumbItem><BreadcrumbLink asChild><Link to="/" className="hover:text-foreground">Home</Link></BreadcrumbLink></BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem><BreadcrumbPage className="text-foreground">{page.title}</BreadcrumbPage></BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="mt-10 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
        <aside className="lg:col-span-4">
          <Reveal className="lg:sticky lg:top-[100px]">
            <div className="eyebrow">Assistenza</div>
            <h1 className="display-xl mt-4 text-foreground" data-testid="service-page-title">{page.title}</h1>
            {page.subtitle && <p className="mt-5 text-lg text-muted-foreground">{page.subtitle}</p>}
            <TrustBand className="mt-10" />
          </Reveal>
        </aside>

        <div className="lg:col-span-7 lg:col-start-6">
          {page.sections && (
            <RevealGroup as="ol" className="divide-y divide-border border-y border-border">
              {page.sections.map((s, i) => (
                <RevealItem as="li" key={s.heading} className="grid grid-cols-1 gap-4 py-8 sm:grid-cols-12 sm:gap-8">
                  <span className="font-mono text-[11px] tracking-mono text-lime sm:col-span-2">{String(i + 1).padStart(2, "0")}</span>
                  <div className="sm:col-span-10">
                    <h2 className="display-lg text-foreground">{s.heading}</h2>
                    <p className="mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">{s.body}</p>
                  </div>
                </RevealItem>
              ))}
            </RevealGroup>
          )}

          {page.faq && (
            <Reveal>
              <Accordion type="single" collapsible className="w-full border-t border-border" data-testid="faq-accordion">
                {page.faq.map((f, i) => (
                  <AccordionItem key={i} value={`faq-${i}`} className="border-border">
                    <AccordionTrigger className="py-6 text-left hover:no-underline [&[data-state=open]_span:first-child]:text-lime">
                      <span className="flex items-start gap-6">
                        <span className="mt-1 font-mono text-[11px] tracking-mono text-muted-foreground transition-colors">{String(i + 1).padStart(2, "0")}</span>
                        <span className="font-display text-lg font-semibold tracking-tightest text-foreground sm:text-xl">{f.q}</span>
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pl-12 text-base leading-relaxed text-muted-foreground">{f.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          )}
        </div>
      </div>
    </div>
  );
}
